import { RequestInterceptor, ResponseError } from 'umi-request';
import { RequestConfig } from 'umi';
import { API_HOST } from '@/const';
import { userTrack } from '@/utils/userTrack';
import { Toast } from 'antd-mobile';
import Cookies from 'js-cookie';

enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 4,
  REDIRECT = 9,
}
interface ErrorInfoStructure {
  success: boolean;
  data?: any;
  errorCode?: string;
  errorMessage?: string;
  showType?: ErrorShowType;
  traceId?: string;
  host?: string;
  [key: string]: any;
}

const HTTP_CODE_MESSAGES: Record<number, string> = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  405: '请求方法不被允许。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

const UN_LOGIN_CODES = [401];

const SUCCESS_CODES = [0, 200];

const errorHandler = (error: ResponseError & { info?: ErrorInfoStructure }) => {
  /**
   * 详细的看.umi/plugin-request吧，源码吐出来的长这样
   * const error: RequestError = new Error(errorInfo.errorMessage);
      error.name = 'BizError';
      error.data = resData;
      error.info = errorInfo;
   * response: http error时候才有 200时候是undefined
   * data：就是服务器返回的完整json
   * message: adator errorMessage
   * info: http error 不走adaptor，bizError走 info就是adaptor return的东西
   */
  const { response, data, message, info, name } = error;
  console.log('message: ', response, data, message, info, error);

  try {
    let url = response?.url || error?.request?.url || info?.ctx?.req?.url;
    const openId = Cookies.get('relx_user_openid') || '';
    try {
      // 防止部分不符合URL规范的url报错，比如某些没有prefix的接口
      const originUrl = new URL(url);
      url = originUrl.pathname
        .split('/')
        .slice(1)
        .join('-');
      console.log('url: ', url);
    } catch (error) {}
    // http错误
    if (response && response.status) {
      const { status, statusText } = response;
      const errorText = HTTP_CODE_MESSAGES[status] || '网络错误';

      setTimeout(() => {
        Toast.show({
          content: errorText,
          icon: 'fail',
        });
      }, 500);
      // 未登录
      if (UN_LOGIN_CODES.includes(data?.code) || response.status === 401) {
      }
      console.log('http error: ', {
        url,
        http_status_code: status || statusText,
        error_type: 'http',
        user_info: {
          open_id: openId,
        },
        // error_request_info: info?.ctx || error,
      });
      userTrack.log('app_request_error', {
        url,
        http_status_code: status || statusText,
        error_type: 'http',
        user_info: {
          open_id: openId,
        },
        // error_request_info: info?.ctx || error,
      });
    } else if (name === 'BizError') {
      // 业务错误（严格来说是 http 200的数据error）
      // 防止clear 提前清掉，放到下一个loop show
      setTimeout(() => {
        Toast.show({
          content: message || '出错了o(╥﹏╥)o',
          icon: 'fail',
        });
      }, 500);
      console.log('biz error: ', {
        url,
        biz_error_code: data?.code,
        biz_error_msg: data?.msg || data?.message,
        error_type: 'biz',
        biz_error_data: data,
        error_request_info: {
          params: info?.ctx?.req?.options?.params,
          data: info?.ctx?.req?.options?.data,
        },
        user_info: {
          open_id: openId,
        },
      });
      userTrack.log('app_request_error', {
        url,
        biz_error_code: data?.code,
        biz_error_msg: data?.msg || data?.message,
        error_type: 'biz',
        biz_error_data: data,
        error_request_info: {
          params: info?.ctx?.req?.options?.params,
          data: info?.ctx?.req?.options?.data,
        },
        user_info: {
          open_id: openId,
        },
      });
    } else {
      setTimeout(() => {
        Toast.show({
          content: '未知错误，请稍后再试',
          icon: 'fail',
        });
      }, 500);
      console.log('unknown error: ', {
        url,
        error_type: 'unknown',
        // error_request_info: info?.ctx || error,
        error_message: error?.message,
        user_info: {
          open_id: openId,
        },
      });
      userTrack.log('app_request_error', {
        url,
        error_type: 'unknown',
        // error_request_info: info?.ctx || error,
        error_message: error?.message,
        user_info: {
          open_id: openId,
        },
      });
    }
  } catch (error) {}
  throw response || data || error;
};

const requestHandler: RequestInterceptor = (url, options) => {
  return {
    url,
    options,
  };
};

type TMiddware = PickArrayItem<Required<RequestConfig>['middlewares']>;

const dataFieldMW: TMiddware = async (ctx, next) => {
  /**
   * TODO: 注意!!!!!!!
   * 这里获取 data 之后, 就要修改配置, 等一个 umi-plugin-request 二次封装
   * {
   *   request: {
   *     dataField: ''
   *   }
   * }
   *
   */
  await next();
  // 给后面错误处理用
  (ctx as any).originRes = ctx.res;
  ctx.res = 'data' in ctx.res ? ctx.res?.data : ctx.res;
};

export const request: RequestConfig = {
  // prefix: '/storeapi',
  timeout: 10000,
  // credentials: 'include',
  // mode: 'cors',
  errorHandler,
  requestInterceptors: [requestHandler],
  // middlewares: [dataFieldMW],
  errorConfig: {
    // 有响应的才走这个adaptor，404 和 别的跨域各种错误不进这里
    adaptor: (resData, ctx) => {
      return {
        ...resData,
        errorCode: resData?.code,
        errorMessage: resData?.msg || resData?.message,
        showType: 2,
        success: SUCCESS_CODES.includes(resData?.code),
        ctx,
      };
    },
  },
};
